import { z } from "zod";

/**
 * Global onchain/DEX configuration settings (Solo CMS)
 * Single-row table for global onchain trading settings
 */
export const OnchainConfigSchema = z.object({
  id: z.string(),
  /**
   * Whether wallet age check is enabled globally for DEX campaigns.
   * If true, wallets must be >=2 weeks old with >=10 recent transactions to be eligible for rewards.
   */
  walletAgeCheckEnabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type OnchainConfig = z.infer<typeof OnchainConfigSchema>;

/**
 * Admin API response for onchain config
 */
export const AdminOnchainConfigResponseSchema = z.object({
  id: z.string(),
  walletAgeCheckEnabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AdminOnchainConfigResponse = z.infer<typeof AdminOnchainConfigResponseSchema>;

/**
 * DTO for updating onchain config
 */
export const UpdateOnchainConfigDtoSchema = z.object({
  id: z.string().optional(),
  walletAgeCheckEnabled: z.boolean(),
});

export type UpdateOnchainConfigDto = z.infer<typeof UpdateOnchainConfigDtoSchema>;

export const UpdateOnchainConfigResponseDtoSchema = z.object({
  id: z.string(),
  message: z.string(),
});

export type UpdateOnchainConfigResponseDto = z.infer<typeof UpdateOnchainConfigResponseDtoSchema>;

export const OnchainSystemMetadataSchema = z.object({
  poolTypes: z.array(z.string()),
  factories: z.array(
    z.object({
      name: z.string(),
      uiName: z.string(),
      logo: z.string().optional(),
      chainId: z.string().optional(),
      address: z.string().optional(),
    }),
  ),
  chains: z.array(
    z.object({
      name: z.string(),
      chainId: z.string().optional(),
      logo: z.string().optional(),
    }),
  ),
});
export type OnchainSystemMetadata = z.infer<typeof OnchainSystemMetadataSchema>;
